/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from "./store/store"

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
    localStorage.setItem('loginRedirect', to.fullPath)
    if (store.state.user._id) {
      if (store.state.user.role.name === 'Authenticated') {
        if (!to.path.startsWith('/global-search') && to.name !== 'asset_view') {
          return next('/global-search');
        } else {
          return next();
        }
      }
      return next();
    } else {
        next('/login');
    }
};

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
              {
                path: '/',
                name: 'home',
                component: () => import('./views/Home.vue'),
                beforeEnter: ifAuthenticated
              },
                {
                    path: '/my-library',
                    name: 'myLibrary',
                    component: () => import('./views/Home.vue'),
                    beforeEnter: ifAuthenticated
                },
              {
                  path: '/advanced-search',
                  name: 'advancedSearch',
                  component: () => import('./views/AdvancedSearchNew.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                  path: '/advanced-search-new',
                  name: 'advancedSearchNew',
                  component: () => import('./views/AdvancedSearchNew.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                  path: '/global-search',
                  name: 'globalSearch',
                  meta: { lmEnabled: true, filterLm: false },
                  component: () => import('./views/GlobalSearch.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                  path: '/demo-content',
                  name: 'globalSearch',
                  meta: { hideSidebar: true },
                  component: () => import('./views/DemoContent.vue')
              },
              {
                path: '/global-search-lm',
                name: 'globalSearchLm',
                meta: { lmEnabled: true, filterLm: true, allowEmpty: true, onlyUs: true},
                component: () => import('./views/GlobalSearch.vue'),
                beforeEnter: ifAuthenticated
              },
              {
                path: '/public-3d-search',
                name: 'public3dSearch',
                meta: { lmEnabled: true, filterLm: true, hideSidebar: true, mobileEnabled: true },
                component: () => import('./views/Public3dSearch.vue'),
              },
              {
                path: '/lti-search',
                name: 'ltiSearch',
                meta: { lmEnabled: true, filterLm: true, hideSidebar: true, mobileEnabled: true },
                component: () => import('./views/LtiSearch.vue')
              },
              {
                path: '/lti/:type/:id',
                name: 'ltiView',
                meta: { lmEnabled: true, filterLm: true, hideSidebar: true, mobileEnabled: true },
                component: () => import('./views/LtiView.vue')
              },
              {
                  path: '/topic-explorer',
                  name: 'topicExplorer',
                  component: () => import('./views/TopicExplorer.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                path: '/duplicates',
                name: 'duplicates',
                component: () => import('./views/Duplicates.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                path: '/create-asset',
                name: 'create',
                component: () => import('./views/Asset.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                path: '/merge',
                name: 'merge',
                component: () => import('./views/Merge.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                path: '/iframe',
                name: 'iframe',
                component: () => import('./views/Iframe.vue')
              },
              {
                  path: '/elastic',
                  name: 'elastic',
                  component: () => import('./views/Elastic.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                  path: '/data-assets',
                  name: 'data-assets',
                  component: () => import('./views/DataAssets.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                  path: '/deleted-assets',
                  name: 'deleted-assets',
                  component: () => import('./views/DataAssets.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                  path: '/review-list',
                  name: 'review-list',
                  component: () => import('./views/ReviewList.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                  path: '/asset-sequence',
                  name: 'asset-sequence',
                  component: () => import('./views/AssetSequence.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                  path: '/translations',
                  name: 'translations',
                  component: () => import('./views/Translations.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                  path: '/user-actions',
                  name: 'user-actions',
                  component: () => import('./views/UserActions.vue'),
                  beforeEnter: ifAuthenticated
              },
              {
                  path: '/bulk-publish',
                  name: 'bulk-publish',
                  component: () => import('./views/bulkPublish.vue'),
                  beforeEnter: ifAuthenticated
              }
            ],
        },
        {
            path: '',
            component: () => import('./layouts/full-page/FullPage.vue'),
            children: [
                {
                    path: '/login',
                    name: 'page-login',
                    component: () => import('./views/pages/Login.vue')
                },
                {
                    path: '/connect/google',
                    name: 'callback',
                    component: () => import('./views/pages/callback.vue')
                },
                {
                    path: '/error-404',
                    name: 'page-error-404',
                    component: () => import('./views/pages/Error404.vue')
                },

            ]
        },
        {
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: '/:id',
                    name: 'asset_view',
                    component: () => import('./views/ViewAsset.vue'),
                    beforeEnter: ifAuthenticated
                },
                {
                    path: '/:id/edit',
                    name: 'edit',
                    component: () => import('./views/Asset.vue'),
                    beforeEnter: ifAuthenticated
                },
                {
                    path: '/:id/:variation_id',
                    name: 'variation_view',
                    component: () => import('./views/ViewAsset.vue'),
                    beforeEnter: ifAuthenticated
                },
            ],
        },
        {
            path: '*',
            redirect: '/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})


export default router

